// removed by extract-text-webpack-plugin
module.exports = {"logotypeCard":"BrandLogotypeScreen_logotypeCard_2ZFB6"};